import { render } from "./FirstTimeLoading.vue?vue&type=template&id=773dfbb2&scoped=true"
import script from "./FirstTimeLoading.vue?vue&type=script&lang=js"
export * from "./FirstTimeLoading.vue?vue&type=script&lang=js"

import "./FirstTimeLoading.vue?vue&type=style&index=0&id=773dfbb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773dfbb2"]])

export default __exports__